import { render, staticRenderFns } from "./DriverProfile.vue?vue&type=template&id=edb8af28&scoped=true&lang=pug&"
import script from "./DriverProfile.vue?vue&type=script&lang=js&"
export * from "./DriverProfile.vue?vue&type=script&lang=js&"
import style0 from "./DriverProfile.vue?vue&type=style&index=0&id=edb8af28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb8af28",
  null
  
)

export default component.exports